import { render, staticRenderFns } from "./CurrencyNew.vue?vue&type=template&id=b1d1ddfa&scoped=true"
import script from "./CurrencyNew.vue?vue&type=script&lang=js"
export * from "./CurrencyNew.vue?vue&type=script&lang=js"
import style0 from "./CurrencyNew.vue?vue&type=style&index=0&id=b1d1ddfa&prod&lang=scss&scoped=true"
import style1 from "./CurrencyNew.vue?vue&type=style&index=1&id=b1d1ddfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d1ddfa",
  null
  
)

export default component.exports